module.exports = __webpack_public_path__ + "img/arrow-left.169bbc88.svg";